module.exports = __webpack_public_path__ + "static/media/oktopi-light.3004ccee.svg";